import { defineStore } from 'pinia'
// @ts-expect-error: Importing Vuex store
import { useStore } from 'vuex'
import { computed } from 'vue'

export const useGoogleAnalyticsStore = defineStore('GoogleAnalytics', () => {
  const vuexStore = useStore()

  const bubbleId = computed(() => vuexStore.getters['families/getBubbleId'])
  const familyWarehouse = computed(() => vuexStore.getters['families/getBubbleName'])
  const provinceId = computed(() => vuexStore.getters['provinces/getCurrentProvinceId'])
  const provinceName = computed(() => vuexStore.getters['provinces/getCurrentProvinceName'])

  const ga = computed(() => ({
    bubbleId: bubbleId.value,
    familyWarehouse: familyWarehouse.value,
    provinceId: provinceId.value,
    provinceName: provinceName.value
  }))

  return { ga, bubbleId, familyWarehouse, provinceId, provinceName }
})
